// extracted by mini-css-extract-plugin
export default {"formGroup":"style_formGroup__-Iwee","labelWrapper":"style_labelWrapper__qNluU","input":"style_input__f7vr2"};